module.exports = [
    "data.service", function (dataService) {
        var organisationSsoStatus = {
            organisationId: null,
            isSsoEnabled: null
        };

        function getOrganisationSsoStatus() {
            debugger;
            return dataService.get("organisationSso")
                .then(function (response) {
                    debugger;
                    organisationSsoStatus.organisationId = response.organisationId;
                    organisationSsoStatus.isSsoEnabled = response.isSsoEnabled;
                    return organisationSsoStatus;
                });
        }

        return {
            getOrganisationSsoStatus: getOrganisationSsoStatus,
            organisationSsoStatus: organisationSsoStatus
        };
    }
];